/* eslint-disable */
import variables from '../scss/_variables.scss';
export default variables;
